// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================REACT & HOOK===================
import { useSelector } from 'react-redux';

// ==================HighCharts===================
import { HighchartsReact } from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
// ==================Actions===================

require('highcharts/modules/accessibility')(Highcharts);

function MultipleMetadataChart() {
  const multipleLinearOptions = useSelector(
    (state) => state.multipleMetadata.dataMultiple.multipleLinearOptions,
  );

  return (
    <div className="multipleDataGraph">
      <HighchartsReact
        highcharts={Highcharts}
        options={multipleLinearOptions}
        containerProps={{
          style: { height: '100%' },
        }}
        oneToOne
        immutable
      />
    </div>
  );
}

export default MultipleMetadataChart;
